import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              Hello! I'm <b className="purple">Ravi Rathore</b>, a passionate
              Full Stack Developer with over 5 years of experience designing and
              building scalable web and backend applications.
              <br />
              <br />I specialize in JavaScript and Node.js, leveraging modern
              frameworks such as{" "}
              <b className="purple">
                React.js, Next.js, Express.js, and NestJS
              </b>{" "}
              to deliver high-performance, user-friendly applications.
              <br />
              <br />
              My expertise includes API-first development and integrating
              third-party services. I am proficient in managing both SQL and
              NoSQL databases, including{" "}
              <b className="purple">
                MySQL, MongoDB, PostgreSQL, and SQL Server
              </b>
              .
              <br />
              <br />
              Additionally, I have experience working with cloud services like{" "}
              <b className="purple">AWS (S3, Lambda, SQS)</b> to optimize
              application performance and ensure secure, scalable solutions.
              <br />
              <br />
              I am adept at leading teams, mentoring junior developers, and
              collaborating effectively within agile environments. I am
              committed to building scalable, fault-tolerant applications while
              continuously learning and staying at the forefront of emerging
              technologies.
              <br />
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>

        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/CoderRathore"
                  style={{ color: "white" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="home-social-icons icon-colour"
                >
                  <AiFillGithub />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/ravirathore-0207b1134"
                  style={{ color: "white" }}
                  target="_blank"
                  className="home-social-icons icon-colour"
                  rel="noopener noreferrer"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
